/**
 * Malay dictionary — key tree must exactly match the zh-HK baseline (enforced by i18n:check).
 * Brand names (JKD Coding / Landlink / Bizpulse) and HK$ prices remain untranslated.
 */
import type { Dict } from '../index';

const dict: Dict = {
  // Site meta
  'meta.title': 'JKD Coding | Using No Way as Way — Perunding Perniagaan AI',
  'meta.description': 'JKD Coding menggabungkan falsafah Jeet Kune Do Bruce Lee untuk membantu NGO, syarikat sosial, dan SME dengan diagnosis penukaran AI, reka bentuk sistem pertumbuhan, dan operasi hubungan pelanggan.',

  // Navbar
  'nav.arsenal': 'Senjata Sedia',
  'nav.components': 'Komponen',
  'nav.custom': 'Tempahan Penuh',
  'nav.philosophy': 'Falsafah',
  'nav.consult': 'Konsultasi Percuma',

  // Hero
  'hero.kicker': 'Be Water, My Friend',
  'hero.titleA': 'Kecerdasan Air',
  'hero.titleB': 'Selesaikan Masalah Perniagaan Dengan Pantas',
  'hero.subtitle': 'JKD Coding mereka bentuk sistem penukaran AI untuk NGO, syarikat sosial, dan SME — tidak memaksa teknologi, hanya mencari bentuk paling semula jadi untuk perniagaan anda: pertumbuhan penderma, pengekalan pelanggan, dan amaran awal aliran tunai dalam satu tempat.',
  'hero.cta': 'Tempah Diagnosis AI',
  'hero.approach': 'Ketahui Kaedah Kami',
  'hero.quote': 'Kosongkan fikiran anda, tanpa bentuk, seperti air.',

  // Services
  'services.tag': 'Amalan Kami',
  'services.title': 'Bukan Jual Alat. Selesaikan Masalah.',
  'services.subtitle': 'Setiap projek bermula dengan kesesakan perniagaan anda, kemudian kami bentukkan AI mengikutnya.',
  'services.m1.eyebrow': '01 / Pertumbuhan',
  'services.m1.title': 'Pertumbuhan Penderma & Pelanggan',
  'services.m1.problem': 'Pelawat datang tetapi tidak bertukar, kos perolehan terus meningkat.',
  'services.m1.solution': 'Reka bentuk fungsi penukaran dipacu AI yang mengubah setiap interaksi menjadi hubungan jangka panjang.',
  'services.m1.result': 'Penukaran lebih tinggi, kos perolehan lebih rendah',
  'services.m2.eyebrow': '02 / Hubungan',
  'services.m2.title': 'Operasi Hubungan Pelanggan',
  'services.m2.problem': 'Susulan terlepas dan pelanggan perlahan-lahan menjadi sejuk.',
  'services.m2.solution': 'Ubah komunikasi satu-ke-satu menjadi operasi hubungan yang boleh diramal dan diskalakan.',
  'services.m2.result': 'Kurang pergian, pengekalan lebih tinggi',
  'services.m3.eyebrow': '03 / Risiko',
  'services.m3.title': 'Amaran Awal Aliran Tunai & Risiko',
  'services.m3.problem': 'Hutang rosak dan perpindahan pesaing hanya disedari selepas berlaku.',
  'services.m3.solution': 'AI memantau isyarat tingkah laku setiap hari dan memberi amaran sebelum risiko berlaku.',
  'services.m3.result': 'Lindungi aliran tunai, bertindak awal',
  'services.m4.eyebrow': '04 / Penggunaan',
  'services.m4.title': 'Penggunaan Perubahan & Kecekapan',
  'services.m4.problem': 'Sistem sudah berjalan, tetapi kakitangan menolak menggunakannya dan kos latihan meningkat.',
  'services.m4.solution': 'Reka bentuk laluan penggunaan bermula dari tabiat sedia ada supaya perubahan terasa semula jadi.',
  'services.m4.result': 'Penggunaan lebih tinggi, kurang ralat',
  'services.m5.eyebrow': '05 / PENGETAHUAN',
  'services.m5.problem': 'Mesyuarat tamat, pengalaman pun mengewap bersamanya.',
  'services.problemLabel': 'Masalahnya',
  'services.solutionLabel': 'Pendekatan Kami',
  'services.cta': 'Tempah diagnosis perniagaan tanpa tekanan',

  // Arsenal
  'arsenal.tag': 'READY-TO-DEPLOY',
  'arsenal.title': 'Senjata Sedia',
  'arsenal.subtitle': 'Penyelesaian berasaskan senario, pelancaran pantas, sedia bertempur',
  'arsenal.blindbox.title': 'Sistem Blind Box',
  'arsenal.blindbox.subtitle': 'Alat Pemasaran Bermusim',
  'arsenal.blindbox.desc': 'Enjin kebarangkalian, pengurusan hadiah, mekanisme viral sosial, papan pemuka analitik. Sesuai untuk pengumpulan dana NGO, promosi e-dagang, interaksi KOL.',
  'arsenal.blindbox.f1': 'Tema bermusim (CNY/Christmas/Mid-Autumn)',
  'arsenal.blindbox.f2': 'Kebarangkalian & mekanisme jaminan tersuai',
  'arsenal.blindbox.f3': 'Ciri buka kunci perkongsian sosial',
  'arsenal.blindbox.f4': 'Papan pemuka analitik lengkap',
  'arsenal.blindbox.f5': 'Sokongan video 30 minit',
  'arsenal.whatsapp.title': 'Sistem Susulan Automatik WhatsApp',
  'arsenal.whatsapp.subtitle': 'Enjin Hubungan Pelanggan',
  'arsenal.whatsapp.desc': 'Aliran kerja pra-konfigurasi fleksibel: pemulihan troli terbengkalai, kemas kini pesanan, pengesahan temujanji, tinjauan kepuasan.',
  'arsenal.whatsapp.f1': 'Perpustakaan templat mesej',
  'arsenal.whatsapp.f2': 'Konfigurasi chatbot',
  'arsenal.whatsapp.f3': 'Integrasi sistem CRM',
  'arsenal.whatsapp.f4': 'Deploy dalam 30 minit',
  'arsenal.whatsapp.f5': 'Sokongan teknikal berterusan',
  'arsenal.promise': '10 minit untuk memiliki fungsi penukaran anda',
  'arsenal.priceFrom': 'Dari',

  // Products
  'products.tag': 'NEW RELEASES',
  'products.title': 'Alat Perniagaan AI',
  'products.subtitle': 'Pembantu AI direka untuk SME. Alami demo interaktif sekarang.',
  'products.cta': 'Cuba Sekarang',
  'products.landlink.title': 'Landlink',
  'products.landlink.subtitle': 'Pembantu Penggunaan Tabiat AI',
  'products.landlink.desc': 'Menyelesaikan masalah "sistem sudah hidup, tetapi kakitangan/pelanggan tidak mahu menggunakannya". AI membaca tabiat sedia ada dan menyediakan langkah seterusnya yang paling kerap, meringkaskan aliran berbilang langkah menjadi satu.',
  'products.landlink.f1': 'Membaca tabiat sedia ada untuk menyediakan langkah seterusnya',
  'products.landlink.f2': 'Ringkasan penggunaan pengurusan + digest WhatsApp harian',
  'products.landlink.f3': 'Mata ganjaran & tindakan ulang satu-klik',
  'products.landlink.f4': 'Menukar 5 langkah kepada 1, mengurangkan kos latihan dan ralat',
  'products.bizpulse.title': 'Bizpulse',
  'products.bizpulse.subtitle': 'Pemantau Risiko Pelanggan AI',
  'products.bizpulse.desc': 'Memantau tingkah laku pelanggan 24/7, mengesan pembayaran lambat, pergian, dan risiko bertukar kepada pesaing lebih awal. Bertindak sebelum hutang rosak berlaku dan lindungi aliran tunai anda.',
  'products.bizpulse.f1': 'Semakan rekod pelanggan harian oleh AI',
  'products.bizpulse.f2': 'Auto-kesan pembayaran melambat & interaksi menyejuk',
  'products.bizpulse.f3': 'Pemberitahuan amaran risiko segera',
  'products.bizpulse.f4': 'Tiada kemahiran AI diperlukan, sedia guna',

  // Components
  'components.tag': 'COMPONENTS LIBRARY',
  'components.title': 'Komponen',
  'components.subtitle': 'Keupayaan modular, gabung mengikut keperluan, autonomi teknikal',
  'components.quote': '"Berfikir adalah masalah, melakukan adalah jawapan"',
  'components.scroll.name': 'Modul Animasi Skrol',
  'components.scroll.tech': 'Intersection Observer API',
  'components.scroll.desc': 'Menyokong 12 kesan tercetus skrol — fade-in, slide-in, zum, putaran — dengan ambang dan kelewatan boleh dikonfigurasi',
  'components.i18n.name': 'Rangka Kerja i18n Dwi-Bahasa',
  'components.i18n.tech': 'Param URL / Pengesanan Pelayar',
  'components.i18n.desc': 'Penukaran kandungan dipacu parameter URL atau pengesanan automatik bahasa pelayar, dengan sokongan RTL disediakan',
  'components.cf-track.name': 'Penjejakan Cloudflare Workers',
  'components.cf-track.tech': 'Serverless',
  'components.cf-track.desc': 'Penjejakan tingkah laku pengguna tanpa pelayan dengan acara tersuai, segmentasi audiens, dan penjejakan GA4 selari',
  'components.cf-webhook.name': 'Cloudflare Workers Webhook',
  'components.cf-webhook.tech': 'HTTP Endpoints',
  'components.cf-webhook.desc': 'Endpoint HTTP piawai dengan pengesahan permintaan, had kadar, dan integrasi Zapier/Make',
  'components.og.name': 'Kit Pengoptimuman Tag OG',
  'components.og.tech': 'Dynamic Meta Tags',
  'components.og.desc': 'Penjanaan tag Open Graph dinamik dengan ujian A/B dan simulasi pratonton media sosial',
  'components.full.title': 'Perpustakaan Komponen Penuh',
  'components.full.desc': 'Semua komponen + sokongan keutamaan + kemas kini suku tahunan. Sesuai untuk projek sederhana hingga besar yang memerlukan keupayaan teknikal sistematik.',
  'components.full.tag1': 'Semua Komponen',
  'components.full.tag2': 'Sokongan Keutamaan',
  'components.full.tag3': 'Kemas Kini Suku Tahunan',
  'components.perYear': '/tahun',
  'components.orMonthly': 'atau HK$200/bulan',

  // Custom
  'custom.tag': 'CUSTOM DOJO',
  'custom.title': 'Custom Dojo',
  'custom.subtitle': 'Fungsi penukaran tempahan penuh, dari sifar ke satu, mencipta mesin penukaran unik anda',
  'custom.price': 'Sebut Harga Projek',
  'custom.priceNote': 'Disesuaikan berdasarkan skop dan kerumitan',
  'custom.phase1.week': 'Week 1',
  'custom.phase1.title': 'Penyelidikan Pesaing & Analisis Peluang',
  'custom.phase1.desc': 'Analisis sistematik 5-10 pesaing teratas: kejuruteraan balik heatmap, penilaian prestasi, pertindihan kata kunci SEO',
  'custom.phase1.deliverable': 'Laporan Analisis Jurang Penukaran',
  'custom.phase2.week': 'Week 1–2',
  'custom.phase2.title': 'Strategi Salinan & Seni Bina Maklumat',
  'custom.phase2.desc': 'Temuduga pengguna Jobs-to-be-Done, 10 varian tajuk, strategi bukti sosial, pengoptimuman CTA',
  'custom.phase2.deliverable': 'Manual Strategi Salinan',
  'custom.phase3.week': 'Week 2–4',
  'custom.phase3.title': 'Reka Bentuk UI/UX & Pengesahan Prototaip',
  'custom.phase3.desc': 'Mod sprint dua-trek, prototaip interaktif Figma berketepatan tinggi, ujian peranti sebenar',
  'custom.phase3.deliverable': 'Prototaip Boleh Klik + Spesifikasi Reka Bentuk',
  'custom.phase4.week': 'Week 4–6',
  'custom.phase4.title': 'Pembangunan Teknikal & Pelancaran',
  'custom.phase4.desc': 'Pembinaan lapisan antara muka pengguna (UI), konfigurasi logik JSON, pelancaran tepi Cloudflare Workers',
  'custom.phase4.deliverable': 'Laman Web Produksi',
  'custom.phase5.week': 'Week 6–8',
  'custom.phase5.title': 'Penjejakan Data & Pengoptimuman',
  'custom.phase5.desc': 'Analisis trafik GA4, peta haba tingkah laku Hotjar, rangka kerja ujian A/B, papan pemuka penukaran tersuai',
  'custom.phase5.deliverable': 'Laporan Pemantauan Data',
  'custom.cta': 'Tempah Konsultasi Percuma',
  'custom.ctaNote': 'Tiada komitmen, fahami keperluan perniagaan anda dahulu',

  // Philosophy
  'philosophy.tag': 'PHILOSOPHY',
  'philosophy.title': 'Falsafah',
  'philosophy.subtitle': 'Metodologi vibe-coding, mengajar anda memancing rather than memberi ikan',
  'philosophy.pillar1.title': 'Falsafah Jeet Kune Do',
  'philosophy.pillar1.desc': 'Falsafah "using no way as way" Bruce Lee bertemu pembangunan agile moden, meneroka bagaimana kebijaksanaan seni mempertahanan berubah menjadi minda pembangunan digital',
  'philosophy.pillar2.title': 'Rangka Kerja Metodologi RPE',
  'philosophy.pillar2.desc': 'Manual lengkap Rapid Prototyping & Execution: temuduga keperluan, pemilihan alat prototaip, ujian pengguna, rentak lelaran',
  'philosophy.pillar3.title': 'Ulasan Alat & Amalan',
  'philosophy.pillar3.desc': 'Ulasan mendalam Bubble, Webflow, Framer dan platform tanpa kod/kod rendah lain. Tanpa gula-gula, membina autoriti objektif',

  // FAQ
  'faq.tag': 'FAQ',
  'faq.title': 'Soalan Lazim',
  'faq.subtitle': 'Jawapan langsung tentang cara JKD Coding berfungsi',
  'faq.q1': 'Apakah jenis organisasi yang anda layani?',
  'faq.a1': 'Kami melayani NGO, syarikat sosial, dan SME di seluruh dunia. Sama ada pertumbuhan penderma, operasi hubungan pelanggan, atau amaran awal aliran tunai, kami sentiasa bermula daripada masalah perniagaan sebenar anda.',
  'faq.q2': 'Apakah diagnosis penukaran AI, dan apa yang berlaku di dalamnya?',
  'faq.a2': 'Ia adalah perbualan perunding satu-ke-satu selama 30 minit. Kami menjelaskan kesesakan perniagaan terbesar anda dan mencari titik kemasukan paling semula jadi untuk AI; selepas itu anda menerima cadangan penambahbaikan konkrit, tanpa tekanan jualan.',
  'faq.q3': 'Bagaimana harga dikira?',
  'faq.a3': 'Penyelesaian sedia bermula HK$800 (Blind Box System) dan HK$1,500 (susulan automatik WhatsApp); komponen individu HK$300–800, perpustakaan penuh HK$2,000/tahun; projek tempahan penuh diquote mengikut skop, biasanya HK$15,000–50,000.',
  'faq.q4': 'Berapa cepat kita boleh Go Live?',
  'faq.a4': 'Penyelesaian sedia dilancarkan dalam 30 minit; perpustakaan komponen dihantar dalam beberapa hari; projek tempahan berjalan melalui lima fasa dan biasanya hidup dalam 6–8 minggu.',
  'faq.q5': 'Kami bukan orang teknikal — bolehkah kami bekerja dengan anda?',
  'faq.a5': 'Sudah tentu. Kami mengurus detail teknikal; anda hanya perlu menyatakan matlamat perniagaan. Semua pertanyaan dijawab dalam 24 jam, dan sokongan teknikal berterusan mengikuti setelah pelan disahkan.',
  'faq.author': 'Penulis: Pasukan JKD Coding',
  'faq.updated': 'Dikemas kini September 2026',

  // Contact
  'contact.tag': 'GET IN TOUCH',
  'contact.title': 'Mulakan Perjalanan Anda',
  'contact.subtitle': '"Hidup... ibarat buang air besar, kadang lembut, kadang keras; kadang lancar, kadang tidak!"',
  'contact.form.title': 'Hantar Mesej',
  'contact.form.name': 'Nama',
  'contact.form.namePlaceholder': 'Nama anda',
  'contact.form.email': 'E-mel',
  'contact.form.emailPlaceholder': 'your@email.com',
  'contact.form.business': 'Jenis Perniagaan',
  'contact.form.businessPlaceholder': 'Pilih jenis perniagaan anda',
  'contact.form.businessNgo': 'NGO / Syarikat Sosial',
  'contact.form.businessSme': 'SME',
  'contact.form.businessPersonal': 'Jenama Peribadi',
  'contact.form.businessOther': 'Lain-lain',
  'contact.form.message': 'Mesej',
  'contact.form.messagePlaceholder': 'Terangkan keperluan atau soalan anda dengan ringkas...',
  'contact.form.submit': 'Hantar Mesej',
  'contact.form.processing': 'Memproses...',
  'contact.form.waNote': 'Langkah seterusnya mengesahkan identiti anda melalui WhatsApp — sila pastikan anda boleh menggunakan WhatsApp.',
  'contact.verify.title': 'Sahkan WhatsApp Anda',
  'contact.verify.desc': 'Klik butang di bawah untuk membuka WhatsApp dan menghantar mesej pengesahan untuk melengkapkan penghantaran anda.',
  'contact.verify.codeLabel': 'Kod Pengesahan Anda / Your Verification Code',
  'contact.verify.openWa': 'Buka WhatsApp untuk Sahkan / Open WhatsApp',
  'contact.verify.prefillNote': 'Mesej pengesahan akan diisi awal / Verification message will be pre-filled',
  'contact.verify.back': '← Kembali / Go Back',
  'contact.success.title': 'Pengesahan Berjaya!',
  'contact.success.desc': 'Kami telah menerima pertanyaan anda dan akan membalas dalam masa 24 jam.',
  'contact.quick.title': 'Hubungan Pantas',
  'contact.quick.whatsapp': 'Konsultasi WhatsApp',
  'contact.quick.whatsappDesc': 'Balas segera, tempah konsultasi percuma',
  'contact.quick.response': 'Janji Tindak Balas Pantas',
  'contact.quick.responseDesc': 'Semua pertanyaan dijawab dalam 24 jam',
  'contact.promise': '"Sama ada anda NGO, syarikat sosial, atau SME, kami akan mencari cara paling langsung untuk membantu anda menemui penyelesaian terbaik. Jangan risau tentang detail teknikal, hanya nyatakan matlamat perniagaan anda."',
  'contact.promiseAuthor': '— Pasukan JKD Coding',
  'contact.alertFail': 'Penghantaran gagal. Sila cuba lagi atau hubungi kami terus di WhatsApp.',
  'contact.waPrefill': 'Helo! Saya ingin mengetahui lebih lanjut tentang perkhidmatan JKD Coding.',

  // Footer
  'footer.desc': 'Menggabungkan falsafah Jeet Kune Do Bruce Lee dengan "using no way as way" sebagai pemikiran inovatif teras, membina fungsi penukaran untuk NGO, syarikat sosial, dan SME.',
  'footer.products': 'Produk',
  'footer.content': 'Kandungan',
  'footer.about': 'Tentang',
  'footer.aboutUs': 'Tentang Kami',
  'footer.contact': 'Hubungi',
  'footer.faq': 'Soalan Lazim',
  'footer.privacy': 'Polisi Privasi',
  'footer.terms': 'Terma Perkhidmatan',
  'footer.rights': 'All rights reserved.',
  // Diagnostic share card (P0 referral entry)
  'share.title': 'Rujuk kepada seorang rakan',
  'share.desc': 'Kenali perniagaan yang bergelut dengan masalah penggunaan sistem? Kongsi diagnosis percuma ini dengan mereka.',
  'share.copy': 'Salin pautan',
  'share.copied': 'Disalin!',
  'share.whatsapp': 'Kongsi melalui WhatsApp',
  'share.more': 'Cara berkongsi lain',
  'share.prefill': 'Seorang rakan mencadangkan saya mencuba diagnosis penukaran AI percuma JKD Coding (30 minit, tanpa tekanan jualan):',

  // Diagnostic page (/diagnosis)
  'diag.tag': 'Panggilan Strategi 30 Minit',
  'diag.title': 'Diagnosis Penukaran AI',
  'diag.subtitle': '30 minit untuk menjelaskan kesesakan perniagaan anda dan mencari titik kemasukan paling semula jadi untuk AI.',
  'diag.back': 'Kembali ke Utama',
  'diag.step1Title': 'Beritahu kami tentang situasi anda',
  'diag.step1Desc': 'Selepas menghantar, perunding kami akan menghubungi anda dalam masa 1 hari bekerja.',
  'diag.name': 'Nama *',
  'diag.organization': 'Organisasi *',
  'diag.role': 'Jawatan *',
  'diag.email': 'E-mel *',
  'diag.businessType': 'Jenis Perniagaan *',
  'diag.businessPlaceholder': 'Pilih',
  'diag.ngo': 'NGO / Syarikat Sosial',
  'diag.sme': 'SME',
  'diag.personal': 'Jenama Peribadi',
  'diag.other': 'Lain-lain',
  'diag.challenge': 'Apakah cabaran penukaran terbesar anda? *',
  'diag.challengePlaceholder': 'Pilih',
  'diag.challenge1': 'Pelawat datang tetapi tidak bertukar',
  'diag.challenge2': 'Susulan terlepas atau tindak balas terlalu lambat',
  'diag.challenge3': 'Hutang rosak atau risiko kehilangan sukar diramal',
  'diag.challenge4': 'Pasukan menolak menggunakan sistem baharu',
  'diag.challenge5': 'Kandungan tidak cukup untuk terus berkomunikasi',
  'diag.goals': 'Matlamat perniagaan yang ingin diselesaikan dahulu *',
  'diag.goalsPlaceholder': 'Terangkan hasil yang anda inginkan dengan ringkas, cth. tingkatkan kadar penyiapan derma sebanyak 30%',
  'diag.budget': 'Julat bajet (pilihan)',
  'diag.budgetPlaceholder': 'Pilih',
  'diag.budget1': 'HK$8,000 – 20,000',
  'diag.budget2': 'HK$20,000 – 50,000',
  'diag.budget3': 'HK$50,000 – 150,000',
  'diag.budget4': 'HK$150,000+',
  'diag.privacy': 'Maklumat anda hanya digunakan untuk mengatur perbualan ini dan tidak akan dijual semula.',
  'diag.submit': 'Tempah Diagnosis Saya',
  'diag.submitting': 'Memproses...',
  'diag.verifyTitle': 'Sahkan WhatsApp Anda',
  'diag.verifyDesc': 'Klik butang di bawah untuk membuka WhatsApp dan menghantar mesej pengesahan untuk melengkapkan tempahan anda.',
  'diag.code': 'Kod Pengesahan Anda',
  'diag.openWhatsApp': 'Buka WhatsApp untuk Sahkan',
  'diag.prefilled': 'Mesej pengesahan akan diisi awal',
  'diag.goBack': 'Kembali',
  'diag.successTitle': 'Pengesahan Berjaya!',
  'diag.successDesc': 'Kami telah menerima permintaan diagnosis anda dan akan membalas dalam masa 24 jam.',
  'diag.alertFail': 'Penghantaran gagal. Sila cuba lagi.',
  'diag.msgOrg': 'Organisasi',
  'diag.msgRole': 'Jawatan',
  'diag.msgChallenge': 'Cabaran terbesar',
  'diag.msgGoals': 'Matlamat untuk diselesaikan dahulu',
  'diag.msgBudget': 'Julat bajet',
  'diag.msgUnfilled': 'Tidak diberikan',

  // Landlink (/landlink)
  'landlink.brandName': 'Landlink',
  'landlink.backAria': 'Kembali ke utama',
  'landlink.brandAria': 'Landlink',
  'landlink.zero.kicker': 'Pembantu Penggunaan Tabiat AI',
  'landlink.zero.titleA': 'Sistem sudah hidup,',
  'landlink.zero.titleB': 'tetapi kakitangan/pelanggan tak nak guna?',
  'landlink.zero.body': 'Landlink membaca rutin sedia ada dan menyediakan tugas paling kerap,',
  'landlink.zero.bodyStrong': 'menukar lima langkah kepada satu.',
  'landlink.zero.cta': 'Lihat di mana geserannya',
  'landlink.zero.dashLabel': 'ADOPTION RATE',
  'landlink.one.kicker': 'AI sedang mengurai geseran penggunaan anda',
  'landlink.one.title': 'Teknologi hidup; tabiat mungkin tidak.',
  'landlink.one.body': 'Tekan 3 isyarat untuk melihat sebab kakitangan atau pelanggan mengelak sistem.',
  'landlink.one.closeAria': 'Tutup',
  'landlink.one.continueNext': 'Teruskan ke isyarat seterusnya →',
  'landlink.one.continueDone': 'Lihat bagaimana AI mengambil alih →',
  'landlink.one.progressPre': 'Isyarat dilihat:',
  'landlink.one.progressPost': '',
  'landlink.one.f1.eyebrow': 'Geseran: Kebiasaan',
  'landlink.one.f1.title': 'Cara lama tanpa kos berfikir',
  'landlink.one.f1.text': 'Kertas dan pen sudah menjadi naluri; walaupun satu langkah tambahan dalam sistem baharu akan ditinggalkan pada saat paling sibuk. Masalahnya bukan fungsi — tetapi kos menukar tabiat.',
  'landlink.one.f2.eyebrow': 'Geseran: Takut silap',
  'landlink.one.f2.title': 'Kakitangan garis depan takut salah tekan',
  'landlink.one.f2.text': 'Apabila hasil operasi tidak jelas, kakitangan garis depan mengambil jalan lama yang paling selamat. Yang mereka perlukan bukan latihan lagi — tetapi maklum balas segera dan pasti.',
  'landlink.one.f3.eyebrow': 'Geseran: Tiada ganjaran',
  'landlink.one.f3.title': 'Perubahan tak kena mengena dengan saya',
  'landlink.one.f3.text': 'Syarikat mendapat kecekapan; kakitangan garis depan hanya merasai susah payah. Ganjaran perlu sampai kepada individu sebelum penggunaan bertukar daripada arahan kepada pilihan.',
  'landlink.two.kicker': 'Ejen AI bukan konsep — lihat satu benar-benar bekerja',
  'landlink.two.titlePre': '5 langkah menjadi ',
  'landlink.two.titleHighlight': '1 langkah',
  'landlink.two.titlePost': '.',
  'landlink.two.body': 'Pesanan sama, dua cara. Jurang itulah pilihan yang dihadapi kakitangan dan pelanggan setiap hari.',
  'landlink.two.startHint': 'Tekan mula untuk melihat AI memampatkan lima langkah menjadi satu tindakan menggunakan tabiat sedia ada.',
  'landlink.two.startCta': 'Mula perbandingan',
  'landlink.two.classicLabel': 'Cara lama',
  'landlink.two.classicStepsLabel': '5 langkah',
  'landlink.two.step1': 'Buka sistem pesanan',
  'landlink.two.step2': 'Pilih setiap item',
  'landlink.two.step3': 'Masukkan kuantiti & spesifikasi',
  'landlink.two.step4': 'Semak butiran penghantaran',
  'landlink.two.step5': 'Sahkan & hantar',
  'landlink.two.orderLabel': 'Pesanan contoh',
  'landlink.two.orderItem': '🥬 Sawi × 2',
  'landlink.two.aiLabel': 'Cara AI',
  'landlink.two.aiStepsLabel': '1 tindakan',
  'landlink.two.aiReadyLabel': 'AI sudah sedia',
  'landlink.two.aiOrder': '🥬 Sawi × 2 · ke cawangan Central · pagi ini',
  'landlink.two.evidenceIntro': 'Berdasarkan tabiat lalu',
  'landlink.two.ev1.label': '4 pesanan terakhir',
  'landlink.two.ev1.value': 'Semua sawi × 2',
  'landlink.two.ev2.label': 'Lokasi penghantaran biasa',
  'landlink.two.ev2.value': 'Cawangan Central · 9 kali',
  'landlink.two.ev3.label': 'Tabiat hari Isnin',
  'landlink.two.ev3.value': 'Biasanya re-stock jam 10 pagi',
  'landlink.two.confirm': 'Sama seperti biasa · Sahkan & hantar',
  'landlink.two.confirmed': 'Disahkan',
  'landlink.two.aiNote': 'AI hanya menggunakan rekod syarikat yang diberi kebenaran — setiap cadangan ada sumbernya.',
  'landlink.three.titlePre': 'Bukan meminta orang berubah —',
  'landlink.three.titleMid': '',
  'landlink.three.titleHighlight': 'menjadikannya berbaloi',
  'landlink.three.titlePost': '.',
  'landlink.three.body': 'Motivasi, keupayaan, dan isyarat semua diperlukan. Landlink mengurangkan geseran dan meningkatkan ganjaran untuk pengurusan dan garis depan serentak.',
  'landlink.three.cta': 'Mula perbualan',
  'landlink.three.card1.title': 'Lapisan pengurusan | Dipacu dari atas',
  'landlink.three.card1.copy': 'Memberi pengurus keterlihatan kemajuan penggunaan dan asas peringatan proaktif harian.',
  'landlink.three.card2.title': 'Lapisan garis depan | Insentif sampai kepada individu',
  'landlink.three.card2.copy': 'Menjadikan sistem baharu lebih pantas, lebih mudah, dan berbaloi dibuka setiap hari.',
  'landlink.four.kicker': 'Pastikan sistem benar-benar berjaya',
  'landlink.four.titlePre': 'Sistem seterusnya untuk berubah',
  'landlink.four.titleMid': 'boleh jadi',
  'landlink.four.titleHighlight': 'sistem anda',
  'landlink.four.titlePost': '.',
  'landlink.four.body': 'Beritahu kami sistem yang anda laksanakan dan kami akan cari langkah yang paling berbaloi didahulukan.',
  'landlink.four.ctaLoading': 'Menyambung anda kepada perunding…',
  'landlink.four.cta': 'Ketahui lebih lanjut di WhatsApp',
  'landlink.four.note': 'Tiada kemahiran teknikal diperlukan · kami bimbing anda',
  'landlink.four.waPrefill': 'Helo, saya ingin mengetahui tentang Landlink, pembantu penggunaan tabiat AI.',

  // Bizpulse (/bizpulse)
  'bizpulse.brandName': 'Bizpulse',
  'bizpulse.backAria': 'Kembali ke utama',
  'bizpulse.title': 'Upah pegawai risiko AI yang tidak pernah malas',
  'bizpulse.kicker': 'Pemantauan risiko pelanggan AI',
  'bizpulse.heroBody': 'Memantau setiap pelanggan untuk anda, 24/7.',
  'bizpulse.heroStrong': 'Pembayaran lambat, pergian, atau perpindahan — AI beritahu anda dahulu.',
  'bizpulse.heroCta': 'Lihat bagaimana AI pantau pelanggan saya',
  'bizpulse.scanLabel': 'AI sedang mengimbas pelanggan anda',
  'bizpulse.one.title': 'AI melihat risiko sebelum ia berlaku.',
  'bizpulse.one.body': 'Tekan 3 amaran merah untuk melihat apa yang AI kesan lebih awal.',
  'bizpulse.one.closeAria': 'Tutup',
  'bizpulse.one.continueNext': 'Teruskan ke amaran seterusnya →',
  'bizpulse.one.continueDone': 'Lihat bagaimana pegawai risiko AI bekerja →',
  'bizpulse.one.progressPre': 'Amaran dilihat:',
  'bizpulse.one.progressPost': '',
  'bizpulse.one.s1.title': 'Mungkin pembayaran lambat',
  'bizpulse.one.s1.tag': 'AI perasan: pembayaran mula melambat',
  'bizpulse.one.s1.detail': 'Tarikh pembayaran pelanggan ini terus tertunda. AI memberi amaran sebelum menjadi hutang rosak supaya anda bisa mengejar awal dan melindungi aliran tunai.',
  'bizpulse.one.s2.title': 'Mungkin pergi',
  'bizpulse.one.s2.tag': 'AI perasan: pelanggan mula sejuk',
  'bizpulse.one.s2.detail': 'Pertanyaan berkurang, balasan melambat, interaksi menurun. AI memantau harian supaya anda bisa mengekalkan mereka sebelum pergi.',
  'bizpulse.one.s3.title': 'Mungkin pindah ke pesaing',
  'bizpulse.one.s3.tag': 'AI perasan: tabiat pesanan berubah',
  'bizpulse.one.s3.detail': 'Frekuensi dan jumlah pesanan mula luar biasa. AI mengesan perubahan halus ini supaya anda bisa merebut tetingkap susulan terakhir.',
  'bizpulse.two.step1.title': 'Sambung rekod',
  'bizpulse.two.step1.copy': 'Satu tempat untuk data pelanggan',
  'bizpulse.two.step2.title': 'Imbasan AI harian',
  'bizpulse.two.step2.copy': 'Kesan tingkah laku luar biasa',
  'bizpulse.two.step3.title': 'Amaran segera',
  'bizpulse.two.step3.copy': 'Beritahu risiko secara langsung',
  'bizpulse.two.step4.title': 'Susulan awal',
  'bizpulse.two.step4.copy': 'Lindungi perniagaan dan tunai',
  'bizpulse.two.finalSmall': 'Pegawai risiko AI anda',
  'bizpulse.two.titlePre': 'Tiada kemahiran AI diperlukan.',
  'bizpulse.two.titleHighlight': 'AI memantau pelanggan anda secara automatik.',
  'bizpulse.two.finalBody': 'Imbas harian, tidak pernah malas; sebaik sahaja ada risiko, anda diberitahu.',
  'bizpulse.two.ctaLoading': 'Menyambung anda kepada perunding…',
  'bizpulse.two.cta': 'Ketahui lebih lanjut di WhatsApp',
  'bizpulse.two.note': 'Tiada kemahiran teknikal diperlukan · kami bimbing anda',
  'bizpulse.two.waPrefill': 'Helo, saya ingin tahu bagaimana mengupah pegawai risiko AI untuk memantau risiko pelanggan saya.',

  // Promo (/promo)
  'promo.kicker': 'Hartanah × automasi media sosial',
  'promo.titlePre': 'Kemas kini senarai, hantaran, analitik —',
  'promo.titleHighlight': 'satu sistem selesaikan semua.',
  'promo.heroLead': 'Sebaik sahaja senarai baharu masuk, ia menjadi hantaran FB profesional dalam 10 saat — penanda air automatik, pautan pendek berjejak, dan statistik senarai mana menarik perhatian.',
  'promo.heroBold': '"Foto ke video"',
  'promo.heroTail': ' — usaha minimum, pengalaman pelanggan maksimum.',
  'promo.videoCaption': '▲ Demo langsung: data hartanah → video satu klik (muzik automatik, sari kata, kad hubungan, QR)',
  'promo.ctaDemo': 'Tempah demo di WhatsApp',
  'promo.ctaTry': 'Cuba dalam talian',
  'promo.waPrefill': 'Saya ingin mengetahui tentang penyelesaian segerak senarai-media sosial',
  'promo.painTitle': 'Tiga perkara yang dihadapi setiap ejen setiap hari',
  'promo.pain1.t': 'Senarai berubah setiap hari',
  'promo.pain1.d': 'Baharu, disewa, dijual — selepas kemas kini laman web, anda perlu hantar di media sosial secara manual juga, berlari dua arah',
  'promo.pain2.t': 'Foto dicuri sebaik sahaja dalam talian',
  'promo.pain2.d': 'Foto senarai yang diambil susah payah dimuat turun dan digunakan semula dalam sekejap — malah suntingan AI tidak dapat menghalangnya',
  'promo.pain3.t': 'Belanja iklan mengalir begitu saja',
  'promo.pain3.d': 'Hantaran keluar tanpa tahu senarai mana mendapat tontonan atau klik — tanpa data tiada arah',
  'promo.stepsTitlePre': 'Daripada senarai ke hantaran —',
  'promo.stepsTitleHighlight': '3 langkah, 10 saat',
  'promo.stepsNote': 'Tangkapan skrin sistem sebenar di bawah, bukan konsep',
  'promo.screenshotAlt': 'Paparan sistem langsung: kawasan promosi sosial',
  'promo.screenshotCaption': '▲ Backend langsung: pilih foto → salinan dijana automatik (boleh disunting) → terbitkan satu klik terus ke FB',
  'promo.step1.t': 'Pilih foto',
  'promo.step1.d': 'Pilih foto hartanah; sistem menambah penanda air jenama pepenjuru tengah — sukar dibuang walaupun dengan suntingan AI',
  'promo.step2.t': 'Hantar',
  'promo.step2.d': 'Salinan hantaran dijana automatik: tajuk, harga jual/sewa, alamat, pautan pendek — tekan "Salin teks" untuk menyunting',
  'promo.step3.t': 'Lihat angka',
  'promo.step3.d': 'Setiap hantaran dilengkapi penjejakan: klik FB, tontonan halaman hartanah — semua kelihatan dalam papan pemuka',
  'promo.magicBadge': 'Ciri pembunuh',
  'promo.magicTitlePre': 'Beberapa foto menjadi',
  'promo.magicTitleHighlight': 'video hartanah profesional.',
  'promo.magicBodyLead': 'Muat naik foto senarai dan sistem menjana video 1080p: muzik automatik, sari kata dinamik (tajuk/harga/alamat), logo jenama, ',
  'promo.magicBodyBold': 'tiada kemahiran sunting, tiada tenaga kerja',
  'promo.magicBodyTail': '. Hantaran video menjangkau jauh melebihi hantaran foto di FB — satu senarai, dua cara bermain.',
  'promo.bullet1': 'Karusel foto + gerakan Ken Burns',
  'promo.bullet2': 'Empat gaya muzik, satu tekan tukar',
  'promo.bullet3': 'Segi empat 1:1 / menegak 9:16, sesuai untuk FB & IG',
  'promo.compareTitle': 'Jom kira',
  'promo.compare.col1': 'Upah / manual',
  'promo.compare.col2': 'Sistem ini',
  'promo.compare.r1.c0': 'Satu hantaran',
  'promo.compare.r1.c1': '30–60 minit',
  'promo.compare.r1.c2': '10 saat',
  'promo.compare.r2.c0': 'Video hartanah',
  'promo.compare.r2.c1': 'Separuh hari + yuran sunting',
  'promo.compare.r2.c2': '1–2 minit, dijana automatik',
  'promo.compare.r3.c0': 'Perlindungan foto',
  'promo.compare.r3.c1': 'Tiada',
  'promo.compare.r3.c2': 'Penanda air gred AI terbina dalam',
  'promo.compare.r4.c0': 'Analitik setiap senarai',
  'promo.compare.r4.c1': 'Tiada / alat berasingan',
  'promo.compare.r4.c2': 'Terbina dalam, sedia di papan pemuka',
  'promo.compare.r5.c0': 'Kos bulanan',
  'promo.compare.r5.c1': '$8,000–15,000',
  'promo.compare.r5.c2': 'Satu yuran bulanan berpatutan',
  'promo.compareNote': '* Sistem sedang berjalan secara langsung dengan ejen hartanah hari ini',
  'promo.ctaTitlePre': 'Senarai seterusnya yang masuk,',
  'promo.ctaTitleHighlight': 'ia di FB 10 saat kemudian.',
  'promo.ctaSub': 'Tempah demo dalam talian 15 minit dan cuba dengan senarai anda sendiri.',
  'promo.ctaNote': 'Berasaskan awan · anda memiliki data · tiada kontrak panjang · sokongan khusus',
  'promo.footer': 'JKD Coding · Using No Way as Way',
  // ===== Distill Kilang Penyulingan Pengetahuan (/distill/) =====
  'distill.meta.title': 'Kilang Penyulingan Pengetahuan — Tukar pengalaman organisasi kepada peraturan yang berfungsi｜JKD Coding',
  'distill.meta.description': 'Kilang Penyulingan Pengetahuan JKD Coding membantu syarikat besar dan PKS mengekstrak pengetahuan: menukar pengalaman yang bertaburan dalam mesyuarat, e-mel dan minda rakan berpengalaman kepada peraturan yang boleh dilaksanakan, boleh diguna semula dan boleh diberi kepada pekerja AI. Sebaik sahaja mesyuarat tamat, peraturan sudah terpamer.',
  'distill.hero.kicker': 'Be Water, My Friend',
  'distill.hero.title': 'Pengetahuan bagaikan air — ia mengambil bentuk apabila dikumpul',
  'distill.hero.tagline': 'KILANG PENYULINGAN PENGETAHUAN',
  'distill.hero.lead': 'JKD Coding menyediakan perkhidmatan pengekstrakan pengetahuan untuk syarikat besar dan PKS: kami menyuling pengalaman yang bertaburan dalam mesyuarat, e-mel dan minda rakan berpengalaman menjadi peraturan yang boleh dilaksanakan dan diguna semula oleh pekerja AI anda — sebaik sahaja mesyuarat tamat, peraturan sudah terpamer.',
  'distill.hero.cta1': 'Tempah diagnosis 30 minit',
  'distill.hero.cta2': 'Kaedah empat langkah',
  'distill.pain.quote.en': 'Absorb what is useful, discard what is useless.',
  'distill.pain.quote.zh': 'Serap apa yang berguna, buang apa yang tidak — Bruce Lee sudah lama mendefinisikan pengekstrakan pengetahuan.',
  'distill.pain.heading': 'Empat cara pengetahuan organisasi mengewap',
  'distill.pain.c1.tt': 'Veteran bersara',
  'distill.pain.c1.ds': 'Dua puluh tahun pertimbangan hilang bersama satu majlis perpisahan — pengalaman itu tidak pernah keluar dari kepalanya.',
  'distill.pain.c2.tt': 'Tanah perkuburan minit mesyuarat',
  'distill.pain.c2.ds': 'Disimpan, tetapi tidak dibaca lagi. Fail ke-4,000 terbenam dalam folder kongsi.',
  'distill.pain.c3.tt': 'SOP termangkuk',
  'distill.pain.c3.ds': ' Lapuk sebaik selesai ditulis — dokumen ketinggalan berbanding amalan sebenar, pekerja baru belajar cara yang salah.',
  'distill.pain.c4.tt': 'AI berongsong kosong',
  'distill.pain.c4.ds': 'Tanpa pengetahuan anda, AI hanyalah bot sembang yang sopan.',
  'distill.method.quote.en': "It's not the daily increase but daily decrease — hack away at the unessential.",
  'distill.method.quote.zh': 'Bukan penambahan harian tetapi pengurangan harian — penyulingan adalah seni memotong. Dinding peraturan diukir, bukan ditimbun.',
  'distill.method.heading': 'Kitaran penyulingan empat langkah',
  'distill.method.s1.tt': 'Sekat',
  'distill.method.s1.en': '01 / INTERCEPT',
  'distill.method.s1.ds': 'Pada hari mesyuarat tamat, rekodnya terus masuk ke dalam kilang — sebelum ia mengewap.',
  'distill.method.s1.out': 'Output: pengetahuan mentah ditangkap',
  'distill.method.s2.tt': 'Suling',
  'distill.method.s2.en': '02 / DISTIL',
  'distill.method.s2.ds': 'AI dan perunding memotong bersama: AI memurnikan, perunding menyingkirkan yang tidak penting.',
  'distill.method.s2.out': 'Output: calon peraturan',
  'distill.method.s3.tt': 'Menghablur',
  'distill.method.s3.en': '03 / CRYSTALLISE',
  'distill.method.s3.ds': 'Semakan manusia mempamerkan peraturan — setiap satu: konteks + tindakan + pemilik.',
  'distill.method.s3.out': 'Output: dinding peraturan',
  'distill.method.s4.tt': 'Guna semula',
  'distill.method.s4.en': '04 / REFLOW',
  'distill.method.s4.ds': 'Pekerja AI bekerja mengikut peraturan; semakan bulanan menajamkannya.',
  'distill.method.s4.out': 'Output: memori organisasi',
  'distill.show.kicker': 'THE DISTILLERY · TAYANGAN',
  'distill.show.heading': 'Perjalanan setitik pengetahuan',
  'distill.show.lead': 'Di atas, bising mentah yang jatuh setiap hari; garisan emas di tengah ialah tangan yang menyekatnya; di bawah, peraturan yang kekal dan berfungsi.',
  'distill.show.ch1': 'minit-mesyuarat_v7_final(2).docx',
  'distill.show.ch2': 'Mesyuarat merentas jabatan ke-38',
  'distill.show.ch3': '"Katanya kita bincang nanti…"',
  'distill.show.ch4': 'Drive kongsi (4,200 fail)',
  'distill.show.ch5': 'Veteran bersara bulan depan',
  'distill.show.ch6': '217 e-mel bolak-balik',
  'distill.show.funnel': 'SEKAT · SULING · ENDAP',
  'distill.show.rule1.tag': 'PERATURAN · MESYUARAT',
  'distill.show.rule1.text': 'Setiap mesyuarat mesti berakhir dengan "siapa + buat apa + bila" — kurang satu, mesyuarat diulang.',
  'distill.show.rule2.tag': 'PERATURAN · LUARAN',
  'distill.show.rule2.text': 'Sebarang janji disahkan secara dalaman sebelum dihantar keluar — tiada siapa bercakap bagi pihak syarikat secara sambil lewa.',
  'distill.show.rule3.tag': 'PERATURAN · DOKUMEN',
  'distill.show.rule3.text': 'Prosedur operasi disemak setiap 90 hari — penulis tandatangan, penyemak meninggalkan jejak.',
  'distill.show.rule4.tag': 'PERATURAN · PERALIHAN',
  'distill.show.rule4.text': 'Pekerja baru membaca dinding peraturan dalam tiga hari, kemudian mula bekerja.',
  'distill.show.note': 'Peraturan contoh adalah ilustrasi generik, bukan pustaka peraturan sebenar mana-mana pelanggan',
  'distill.proof.kicker': 'BUKTI AMALAN',
  'distill.proof.heading': 'Kami tidak mengajar penyulingan — kami menyuling setiap hari',
  'distill.proof.s1.n': '252',
  'distill.proof.s1.l': 'peraturan kerja terus disuling dalam sistem tadbir urus kami sendiri',
  'distill.proof.s2.n': 'Mingguan',
  'distill.proof.s2.l': 'irama tuaian dan semakan, tidak pernah terlepas',
  'distill.proof.s3.n': '6 bahasa',
  'distill.proof.s3.l': 'pengalaman tadbir urus pengetahuan merentas tapak, terus boleh dipindahkan',
  'distill.proof.quote.en': 'Using no way as way — having no limitation as limitation.',
  'distill.proof.quote.zh': 'Menggunakan tiada kaedah sebagai kaedah — peraturan disuling daripada amalan sebenar, bukan disalin daripada templat.',
  'distill.fit.heading': 'Untuk siapa perkhidmatan ini',
  'distill.fit.f1.tt': 'NGO',
  'distill.fit.f1.ds': 'Hubungan penderma dan pengalaman sukarelawan tidak lagi hilang setiap kali staf bertukar.',
  'distill.fit.f2.tt': 'Perusahaan sosial',
  'distill.fit.f2.ds': 'Pengalaman misi dan operasi diwarisi tanpa berubah bentuk ketika berkembang.',
  'distill.fit.f3.tt': 'PKS',
  'distill.fit.f3.ds': 'Tukar pertimbangan pemilik kepada sistem yang boleh diguna seluruh syarikat.',
  'distill.fit.f4.tt': 'Syarikat besar',
  'distill.fit.f4.ds': 'Tadbir urus pengetahuan merentas jabatan: pengalaman tersirat setiap pasukan menjadi peraturan yang boleh dilaksanakan pekerja AI.',
  'distill.faq.q1': 'Berapa lama masa penyulingan?',
  'distill.faq.a1': 'Pusingan pertama menyasarkan penghantaran hari yang sama: pada hari mesyuarat tamat, peraturannya sudah terpamer. Kitaran penuh — sekat, suling, endap, guna semula — bergerak setiap minggu mengikut saiz organisasi, kemudian terus berputar melalui semakan bulanan.',
  'distill.faq.q2': 'Adakah pengetahuan kami akan bocor?',
  'distill.faq.a2': 'Tidak. Peraturan yang disuling adalah milik anda dan disimpan dalam bidang kuasa anda; kami memprosesnya hanya sepanjang tempoh perkhidmatan dengan kebenaran anda, dan berundur selepas penghantaran.',
  'distill.faq.q3': 'Apakah beza ini dengan alat pengurusan pengetahuan AI biasa?',
  'distill.faq.a3': 'Alat hanya menyimpan; penyulingan memotong dan membentuk. Tanpa struktur peraturan "siapa + buat apa + bila", data sebanyak mana pun tidak boleh dilaksanakan — kami menghantar pertimbangan, bukan pangkalan data.',
  'distill.faq.q4': 'Bagaimana peraturan tersuling disambungkan kepada pekerja AI?',
  'distill.faq.a4': 'Dinding peraturan ialah asas kerja pekerja AI: pengurus projek AI bertindak mengikut peraturan dan mengesahkan secara dalaman mengikut peraturan; semakan bulanan memasukkan pengalaman baru sebagai peraturan baru — satu gelung tertutup.',
  'distill.faq.q5': 'Adakah pendekatan berbeza antara syarikat besar dan PKS?',
  'distill.faq.a5': 'PKS fokus keinstitusian pertimbangan pemilik; syarikat besar memerlukan tadbir urus merentas jabatan — pengalaman tersirat setiap pasukan disatukan menjadi set peraturan yang tidak bercanggah dan boleh dilaksanakan.',
  'distill.faq.q6': 'Bagaimana cara memulakan?',
  'distill.faq.a6': 'Mulakan dengan diagnosis 30 minit: senaraikan aset pengetahuan organisasi anda yang paling bernilai — dan paling berisiko (mengewap) — kemudian tentukan skop dan irama penyulingan.',
  'distill.funnel.heading': 'Dari setitik bising kepada satu pasukan pekerja AI',
  'distill.funnel.f1.tag': 'LANGKAH 1',
  'distill.funnel.f1.tt': 'Diagnosis',
  'distill.funnel.f1.ds': 'Sesi satu-dengan-satu 30 minit untuk menyenaraikan aset pengetahuan paling bernilai — dan paling berisiko (mengewap).',
  'distill.funnel.f2.tag': 'LANGKAH 2 · HALAMAN INI',
  'distill.funnel.f2.tt': 'Penyulingan pengetahuan',
  'distill.funnel.f2.ds': 'Kitaran empat langkah mempamerkan peraturan — pengetahuan akhirnya ada bentuk.',
  'distill.funnel.f3.tag': 'LANGKAH 3',
  'distill.funnel.f3.tt': 'Pekerja AI terurus',
  'distill.funnel.f3.ds': 'Pengurus projek AI di lokasi, bekerja daripada dinding peraturan anda — kami menjual pekerja, bukan perisian.',
  'distill.cta1': 'Bual di WhatsApp',
  'distill.cta2': 'Tentang diagnosis',
  'distill.wa.text': 'Hai! Saya ingin mengetahui tentang perkhidmatan Kilang Penyulingan Pengetahuan JKD Coding.',
  'distill.footer': 'JKD Coding · Using no way as way',
  'distill.card.title': 'Pengekstrakan pengetahuan',
  'distill.card.desc': 'Suling pengalaman yang bertaburan dalam mesyuarat dan minda rakan berpengalaman menjadi peraturan yang boleh dilaksanakan pekerja AI anda.',
  'distill.card.cta': 'Masuk ke Kilang Penyulingan',
  'distill.xs.title': 'Selepas diagnosis: suling penemuan menjadi peraturan',
  'distill.xs.body': 'Diagnosis mencari puntong; Kilang Penyulingan Pengetahuan menukar pengalaman organisasi menjadi peraturan yang boleh dilaksanakan, diguna semula dan diberi kepada pekerja AI — sebaik mesyuarat tamat, peraturan sudah terpamer.',
  'distill.xs.cta': 'Masuk ke Kilang Penyulingan',

  // ============ Terma & Syarat /terms (3 tab: Privasi / Bayaran Balik / Penghantaran) ============
  'terms.meta.title': 'Terma & Syarat — Dasar Privasi, Bayaran Balik & Penghantaran | JKD Coding',
  'terms.meta.description': 'Terma & syarat JKD Coding (dikendalikan oleh Wiseman Consultancy Limited): Dasar Privasi, Dasar Bayaran Balik dan Dasar Penghantaran, terpakai untuk laman web ini dan semua perkhidmatan perundingan dan pembangunan digital.',
  'terms.title': 'Terma & Syarat',
  'terms.subtitle': 'Terma ini terpakai untuk laman web JKD Coding (jkdcoding.com) dan semua perkhidmatan perundingan serta digital yang kami sediakan. Laman web dan perkhidmatan dikendalikan oleh Wiseman Consultancy Limited.',
  'terms.updated': 'Kemas kini terakhir: 2026-10-13',
  'terms.tab.privacy': 'Dasar Privasi',
  'terms.tab.refund': 'Dasar Bayaran Balik',
  'terms.tab.delivery': 'Dasar Penghantaran',
  'terms.contact': 'Jika ada pertanyaan, hubungi kami melalui WhatsApp +852 5165 1480.',

  // — Dasar Privasi —
  'terms.privacy.note': 'Dasar ini menerangkan bagaimana JKD Coding (dikendalikan oleh **Wiseman Consultancy Limited**) mengumpul, menggunakan dan melindungi data anda. Dengan menggunakan laman web atau perkhidmatan ini, anda bersetuju dengan terma dasar ini.',
  'terms.privacy.h1': '1. Data Yang Kami Kumpul',
  'terms.privacy.s1': '- **Data pertanyaan & hubungan**: nama, nombor WhatsApp, e-mel, organisasi (melalui tempahan diagnosis, WhatsApp atau borang)\n- **Data projek**: bahan perniagaan, kandungan pangkalan pengetahuan dan aset laman web yang anda sediakan\n- **Data penyemakan imban**: kunjungan halaman, perujuk dan parameter pemasaran (statistik tanpa nama untuk memperbaiki laman web dan prestasi iklan)\n- **Data pembayaran**: kami hanya menyimpan nombor invois dan jumlah, dan **tidak pernah melihat atau menyimpan butiran alat pembayaran anda**',
  'terms.privacy.h2': '2. Cara Kami Guna Data',
  'terms.privacy.s2': '- Menyediakan, mengendalikan dan memperbaiki perkhidmatan perundingan dan pembangunan kami\n- Sebut harga, pengurusan projek, sokongan teknikal dan pengebilan\n- Notis perkhidmatan penting (pengesahan tempahan, aturan penghantaran, amaran keselamatan)',
  'terms.privacy.h3': '3. Pemprosesan Pihak Ketiga (Enjin AI)',
  'terms.privacy.s3': 'Untuk menyediakan perkhidmatan berkaitan AI, kandungan yang anda berikan mungkin dihantar kepada pembekar model bahasa besar yang kami gunakan (termasuk DeepSeek, Z.ai dan lain-lain), yang memproses data di bawah dasar privasi masing-masing. Kami hanya menghantar kandungan yang diperlukan untuk menyiapkan kerja, dan sentiasa menilai aturan perlindungan data mereka.',
  'terms.privacy.h4': '4. Penyimpanan Data',
  'terms.privacy.s4': '- Rekod pertanyaan dan perbualan: disimpan lebih kurang 24 bulan, kemudian dibersihkan\n- Fail projek: disimpan 90 hari selepas penghantaran untuk pembaikan dan sokongan, kemudian dipadam atas permintaan atau dibersihkan secara automatik',
  'terms.privacy.h5': '5. Yang Tidak Pernah Kami Lakukan',
  'terms.privacy.s5': '- Kami tidak menjual atau menyewakan data anda\n- Kami tidak menggunakan data anda — atau pelanggan anda — untuk pemasaran pihak ketiga\n- Kami tidak mendedahkan data kepada pihak ketiga kecuali diwajibkan oleh undang-undang atau perlu untuk menyediakan perkhidmatan (cth. enjin AI, pembekal pengehosan dan pembayaran)',
  'terms.privacy.h6': '6. Hak Anda',
  'terms.privacy.s6': 'Anda berhak mengakses, membetulkan atau memadamkan data peribadi anda. Hantar permintaan melalui WhatsApp +852 5165 1480; kami respons dalam tempoh **14 hari**. Pengendalian data peribadi kami mematuhi Ordinan Data Peribadi (Privasi) (Bab 486, Undang-Undang Hong Kong).',
  'terms.privacy.h7': '7. Kemas Kini Dasar',
  'terms.privacy.s7': 'Perubahan penting akan disiarkan di halaman ini dengan tarikh kemas kini. Perubahan yang memberi kesan besar kepada penggunaan perkhidmatan akan dimaklumkan secara berasingan.',

  // — Dasar Bayaran Balik —
  'terms.refund.note': 'JKD Coding menyediakan perkhidmatan perundingan dan pembangunan digital (bukan barangan fizikal). Semua harga dalam HKD. Kami menggalakkan anda menempah **diagnosis percuma** (30 minit satu-dengan-satu) dahulu dan memutuskan dengan jelas sebelum membayar.',
  'terms.refund.h1': '1. Diagnosis Percuma',
  'terms.refund.s1': 'Diagnosis adalah percuma sepenuhnya tanpa tekanan jualan. Semua kerja berbayar dipetik selepas diagnosis dan bermula hanya selepas pengesahan bertulis anda.',
  'terms.refund.h2': '2. Pembatalan Sebelum Kerja Bermula',
  'terms.refund.s2': 'Jika anda membatalkan selepas pengesahan tetapi sebelum kerja bermula: semua bayaran **dipulangkan sepenuhnya**. Kos pihak ketiga yang telah ditanggung bagi pihak anda (domain, lesen, sumber awan dll.) ditolak pada kos sebenar berserta resit.',
  'terms.refund.h3': '3. Pelan Sedia Ada & Pustaka Komponen',
  'terms.refund.s3': 'Dalam tempoh **7 hari** selepas pembayaran, jika perkhidmatan gagal dihantar atau beroperasi kerana kesalahan kami dan kami tidak dapat membaikinya dalam masa yang munasabah, anda boleh memohon **bayaran balik penuh**. Setelah berjaya dihantar dan beroperasi normal, perkhidmatan dianggap selesai dan tidak boleh dikembalikan.',
  'terms.refund.h4': '4. Projek Tempahan (Berasaskan Batu Milestone)',
  'terms.refund.s4': '- Projek tempahan ditulis bil setiap batu milestone: **milestone yang telah dimulakan** diselesaikan mengikut kemajuan sebenar; **milestone yang belum dimulakan** boleh dikembalikan\n- Pembatalan di tengah jalan: kerja yang siap dan diterima tidak dikembalikan; bakinya dipulangkan secara pro-rata\n- Permintaan ubah suai selepas penghantaran adalah skop baharu dan dipetik berasingan',
  'terms.refund.h5': '5. Kesilapan Pengebilan',
  'terms.refund.s5': 'Caj berganda atau caj salah, setelah disahkan, akan dipulangkan sepenuhnya ke kaedah pembayaran asal dalam tempoh **7 hari bekerja**.',
  'terms.refund.h6': '6. Cara Memohon',
  'terms.refund.s6': 'WhatsApp +852 5165 1480 (sila berikan nombor invois anda). Semua permohonan diproses dalam tempoh **7 hari bekerja**; bayaran balik dikembalikan melalui saluran pembayaran asal.',

  // — Dasar Penghantaran —
  'terms.delivery.note': 'JKD Coding menyediakan perkhidmatan digital semata-mata — **tiada penghantaran fizikal**. Semua penghantaran adalah secara elektronik; tiada caj penghantaran dikenakan.',
  'terms.delivery.h1': '1. Tempoh Penghantaran',
  'terms.delivery.s1': '- **Pelan sedia ada**: pelaksanaan secepat 30 minit selepas keperluan disahkan dan pembayaran diterima (waktu bekerja)\n- **Pustaka komponen**: lesan dan dokumen dihantar melalui e-mel/WhatsApp dalam tempoh 1 hari bekerja selepas pembayaran\n- **Projek tempahan**: dihantar mengikut batu milestone kontrak, lazimnya tayalan dalam 6–8 minggu\n- Permintaan di luar waktu bekerja dikendalikan pada sesi bekerja berikutnya; semua pertanyaan dijawab dalam tempoh 24 jam',
  'terms.delivery.h2': '2. Apa Yang Dihantar',
  'terms.delivery.s2': 'Bergantung pada pelan, penghantaran lazimnya merangkumi: akses ke laman web/sistem, kod sumber atau persekitaran pelaksanaan, panduan persediaan dan penggunaan, serta saluran sokongan teknikal.',
  'terms.delivery.h3': '3. Kaedah Penghantaran',
  'terms.delivery.s3': 'Semuanya dihantar secara elektronik (web, e-mel, WhatsApp). Setelah pelaksanaan selesai dan kedua-dua pihak menerima kerja tersebut, perkhidmatan dianggap telah dihantar dan bermula.',
  'terms.delivery.h4': '4. Kelewatan Penghantaran',
  'terms.delivery.s4': 'Jika penghantaran melebihi tempoh yang dijanjikan, anda boleh memilih **penghantaran semula segera** atau memohon bayaran balik di bawah [Dasar Bayaran Balik](#refund).',

  // — Pautan terma footer —
  'footer.termsLink': 'Terma & Syarat',
};

export default dict;
